<div class="error">
    <img src="assets/icons/icon-exclamation-circle.svg" class="exclamation-circle" alt="exclamation-circle" />
    <span class="text-[#991B1B] font-medium"><ng-content></ng-content></span>
</div>